var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.URL)?_c('iframe',{attrs:{"src":_vm.URL,"frameborder":"0","allowfullscreen":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }